import { render } from "./CardTypeConsumeComponent.vue?vue&type=template&id=58066b1b"
import script from "./CardTypeConsumeComponent.vue?vue&type=script&lang=js"
export * from "./CardTypeConsumeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__